export default __webpack_public_path__ + "static/media/linkedIn.fa8bfab7.svg";